module.exports = __webpack_public_path__ + "img/GM.eb0c7cba.svg";